import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Row, Col, Input, Select, Button, Checkbox } from 'antd';
const Option = Select.Option;

@inject('store')
@observer
export class ManualFormComponent extends Component {
    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const { config } = this.props.store.odysseyBotStore;

                let providers = { ...config.signal_providers } || {};
                providers[this.props.location] = values;

                const next = { ...config };
                next.signal_providers = providers;

                this.props.store.odysseyBotStore.updateConfig(next);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                <Row gutter={24}>
                    <Col md={3}>
                        <Form.Item label="Enable Service">
                            {getFieldDecorator('enabled', {
                                valuePropName: 'checked',
                                initialValue: false
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label="Strategy">
                            {getFieldDecorator('strategy_id', {})(
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                    optionFilterProp="name"
                                >
                                    {this.props.store.strategyStore.odysseySignal
                                        .slice()
                                        .sort((a, b) => {
                                            if (a.name < b.name) return -1;
                                            if (a.name > b.name) return 1;
                                            return 0;
                                        })
                                        .map(s => {
                                            return (
                                                <Option value={s._id} key={s._id}>
                                                    {s.name}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label="Api Key" required={true}>
                            {getFieldDecorator('api_key', {
                                rules: [{ required: true, message: 'Field is required' }]
                            })(<Input.Password />)}
                        </Form.Item>
                    </Col>
                </Row>

                <div style={{ textAlign: 'right' }}>
                    <Button onClick={this.handleSubmit.bind(this)} type="primary">
                        Save
                    </Button>
                </div>
            </div>
        );
    }
}

export const ManualSignalForm = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(k => {
            data[k] = Form.createFormField({ value: props.data[k] });
        });
        return data;
    }
})(ManualFormComponent);



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/SignalsView/ManualSignalForm.js